export default (theme) => ({
  container: {
    padding: 5,
  },
  flex: {
    width: 40,
    padding: 8,
  },
});
